import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Timeline from "./Timeline";
import { getAgent } from "../../redux/actions/agents";
import { useDispatch, useSelector } from "react-redux";

const statusStyles = {
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  red: "bg-red-100 text-red-800",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AgentDetailAdmin() {
  const [prevStatus, setPrevStatus] = useState(null);

  const { id } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAgent({ id }));
  }, [dispatch, id]);

  const { agent } = useSelector((state) => state.agents);

  console.log("ASDFGHJKL", agent);

  useEffect(() => {
    if (agent !== null) {
      setPrevStatus(agent.attributes.loanStatus);
    }
  }, [agent]);

  console.log(prevStatus);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  console.log("----------------------------");
  console.log(agent);
  console.log("----------------------------");

  return (
    <>
      {agent !== null && (
        <div className="min-h-full">
          <main className="py-10">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
              <div className="flex items-center space-x-5">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    {agent.attributes.name}
                  </h1>
                  <p className="text-sm font-medium text-gray-500">
                    Agent since:{" "}
                    <span>{formatDate(agent.attributes.agentSince)}</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
              <div className="space-y-6 lg:col-start-1 lg:col-span-2">
                {/* Description list*/}
                <section aria-labelledby="applicant-information-title">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="flex items-center justify-between px-4 py-5 sm:px-6">
                      <div>
                        <h2
                          id="applicant-information-title"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Agent Information
                        </h2>
                        <p className="mt-1 max-w-2xl text-sm text-gray-500">
                          Personal details about the agent.
                        </p>
                      </div>
                    </div>

                    <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Name:
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            <span className="flex-grow">
                              {agent.attributes.name}
                            </span>
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Phone Number
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            <span className="flex-grow">
                              {agent.attributes.phoneNo}
                            </span>
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Loan
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            <span className="flex-grow">
                              {parseInt(agent.attributes.loan)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                              Birr
                            </span>
                          </dd>
                        </div>
                        <div className="sm:col-span-2">
                          <dt className="text-sm font-medium text-gray-500">
                            Loan Status
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            <span
                              className={classNames(
                                statusStyles[agent.attributes.loanStatus],
                                "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                              )}
                            >
                              {agent.attributes.loanStatus}
                            </span>
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </section>
              </div>

              <Timeline id={id} agent={agent} />
            </div>
          </main>
        </div>
      )}
    </>
  );
}
